import React from 'react';
import TabbedPage from '../../../Elements/TabbedPage';
import OutstandingTpClientInvoiceAdmin from './OutstandingTpClientInvoiceAdmin';
import AppliedTpClientInvoiceAdmin from './AppliedTpClientInvoiceAdmin';
import OutstandingClientInvoiceAdmin from './OutstandingClientInvoiceAdmin';
import AppliedClientInvoiceAdmin from './AppliedClientInvoiceAdmin';

export default class InvoiceParentAdmin extends React.Component {
  static defaultProps = {
    tpClientPaymentId: 0,
  };

  constructor(props) {
    super(props);

    this.state = {};
  }

  tabs = [
    {
      label: 'Outstanding Invoices',
      id: 'outstanding',
      icon: 'fa-solid fa-file-invoice',
      component: <OutstandingClientInvoiceAdmin tpClientPaymentId={this.props.tpClientPaymentId} />,
    },
    {
      label: 'Outstanding Third-Party Invoices',
      id: 'outstanding_new',
      icon: 'fa-solid fa-file-invoice',
      component: <OutstandingTpClientInvoiceAdmin tpClientPaymentId={this.props.tpClientPaymentId} />,
    },
    {
      label: 'Applied Invoices',
      id: 'applied',
      icon: 'fa-solid fa-file-invoice-dollar',
      component: <AppliedClientInvoiceAdmin tpClientPaymentId={this.props.tpClientPaymentId} />,
    },
    {
      label: 'Applied Third-Party Invoices',
      id: 'applied_new',
      icon: 'fa-solid fa-file-invoice-dollar',
      component: <AppliedTpClientInvoiceAdmin tpClientPaymentId={this.props.tpClientPaymentId} />,
    },
  ];

  render() {
    return (
      <div className='contentwrapper'>
        <TabbedPage
          tabs={this.tabs}
          removeSearchParametersOnTabChange={true}
        />
      </div>
    );
  }
}
